import { Select } from "antd";
import { SelectProps } from "antd/lib";
import React from "react";

export const CacheTypeSelect = (props: SelectProps) => {
  return (
    <Select {...props} defaultValue="CACHE_TYPE_FULL_LOAD">
      <Select.Option value="CACHE_TYPE_FULL_LOAD">Full</Select.Option>
      <Select.Option value="CACHE_TYPE_PARTIAL_LOAD">Partial</Select.Option>
      <Select.Option value="CACHE_TYPE_STREAM_LOAD">Stream</Select.Option>
    </Select>
  );
};
